import { render } from "./FreebetCampaignClone.vue?vue&type=template&id=a2d0f5d2&scoped=true"
import script from "./FreebetCampaignClone.vue?vue&type=script&lang=js"
export * from "./FreebetCampaignClone.vue?vue&type=script&lang=js"

import "./FreebetCampaignClone.vue?vue&type=style&index=0&id=a2d0f5d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d0f5d2"]])

export default __exports__